import styled from '@emotion/styled';
import { alpha } from '@mui/system';
import { Link } from 'react-router-dom';

import { hoverable } from '@/design-system';

export const NotificationMessagesButton = styled(Link)(({ theme }) => ({
  ...hoverable(theme, 'lift'),
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  backgroundColor: alpha(theme.colors.orange.solid, 0.2),
  padding: '9px 12px',
  gap: '8px',
  borderRadius: 8,
  boxShadow: `0px 4px 10px 0px ${alpha(theme.colors.black[100], 0.03)}`,
  textDecoration: 'none',
}));

export const NotificationsBadge = styled('div')(({ theme }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  backgroundColor: theme.colors.orange.solid,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
